// Not lucide's Plus: Figma strokes 1 in 32, lucide's is nearly three times as
// heavy at the same size.
const IconPlus = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden className={className}>
    <path
      d="M4 16H28M16 4V28"
      stroke="currentColor"
      strokeWidth={1}
      strokeLinecap="round"
    />
  </svg>
);

export default IconPlus;
